export const LANGUAGES = [
  "Afrikaans",
  "Albanian",
  "American Sign Language (ASL)",
  "Amharic",
  "Arabic",
  "Armenian",
  "Basque",
  "Bengali",
  "Byelorussian",
  "Burmese",
  "Bulgarian",
  "Catalan",
  "Czech",
  "Chinese (Cantonese)",
  "Chinese (Mandarin)",
  "Croatian",
  "Danish",
  "Dari",
  "Dzongkha",
  "Dutch",
  "Esperanto",
  "Estonian",
  "Faroese",
  "Farsi",
  "Finnish",
  "French",
  "Gaelic",
  "Galician",
  "German",
  "Greek",
  "Hebrew",
  "Hindi",
  "Hungarian",
  "Icelandic",
  "Indonesian",
  "Inuktitut (Eskimo)",
  "Italian",
  "Japanese",
  "Khmer",
  "Korean",
  "Kurdish",
  "Laotian",
  "Latvian",
  "Lappish",
  "Lithuanian",
  "Macedonian",
  "Malay",
  "Maltese",
  "Nepali",
  "Norwegian",
  "Pashto",
  "Polish",
  "Portuguese",
  "Romanian",
  "Russian",
  "Scots",
  "Serbian",
  "Slovak",
  "Slovenian",
  "Somali",
  "Spanish",
  "Swedish",
  "Swahili",
  "Tagalog (Filipino)",
  "Tajik",
  "Tamil",
  "Thai",
  "Tibetan",
  "Tigrinya",
  "Tongan",
  "Turkish",
  "Turkmen",
  "Ukrainian",
  "Urdu",
  "Uzbek",
  "Vietnamese",
  "Welsh",
];
